/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useContext, useMemo } from 'react';
import PropTypes, { func, object } from 'prop-types';

import { CentroDeCusto, LoadGif } from 'src/components';
import { RenderForm, showToast } from 'src/components';
import { RenderPdf } from 'src/components';
import { LogContext } from 'src/components/LogProvider';
import { Anexos } from 'src/components/customInput/anexos';
import { fileService } from 'src/components/customInput/fileServer';
import Rateios from 'src/components/rateios';

import {
  actionDinamyc,
  getMsgRet,
  GetProcesso,
  getRelatorio,
  isValid,
  isRetornoSucesso,
  LogGetProcesso,
  transformJson,
  transformResponse,
} from 'src/services/auth';

import CustomInput, {
  ConsultaInput,
  SelectInput,
  SelectInput2,
  Toogle,
} from '../../customInput';

import SubForm from '../subForm';
import SearchTable from '../searchTable';

import { ReactSVG } from 'react-svg';

import { OtherHouses, Search } from '@mui/icons-material';

import { isDark } from 'src/components/DetectBrightness';
import { newTab, newTabRef } from 'src/pages/home';

import { ReactComponent as ArchiveIcon } from 'src/assets/icons/archive.svg';
import { ReactComponent as Check } from 'src/assets/icons/check.svg';
import { ReactComponent as ClearIcon } from 'src/assets/icons/clear.svg';
import { ReactComponent as DeleteIcon } from 'src/assets/icons/delete.svg';
import { ReactComponent as End } from 'src/assets/icons/end.svg';
import { ReactComponent as GoBack } from 'src/assets/icons/goBack.svg';
import { ReactComponent as Lock } from 'src/assets/icons/lock.svg';
import { ReactComponent as Pdf } from 'src/assets/icons/pdf.svg';
import { ReactComponent as Plug } from 'src/assets/icons/plug.svg';
import { ReactComponent as Plugged } from 'src/assets/icons/plugged.svg';
import { ReactComponent as SaveIcon } from 'src/assets/icons/save.svg';
import { ReactComponent as ShowTodos } from 'src/assets/icons/restore.svg';
import { ReactComponent as TypeList } from 'src/assets/icons/typeList.svg';
import { ReactComponent as TypeNormal } from 'src/assets/icons/typeNormal.svg';
import { ReactComponent as Menu } from 'src/assets/icons/menu.svg';
import DefIcon from 'src/assets/base/page.svg';

export default function SubformEditar({
  onClose,
  children,
  controls,
  data,
  config,
  rowData,
  tabIndex,
  forceUpdate,
}) {
  const colunas = useMemo(
    () => JSON.parse(data.nomeColunas),
    [data.nomeColunas]
  );
  const dados = data;

  const idEmp = localStorage.getItem('idEmp');
  const idFil = localStorage.getItem('idFil');
  const showRateio = colunas?.Dados?.rateio === 'S';
  const rateioValor = colunas?.Dados?.rateiovalor ?? 0;
  const abas = colunas?.Dados?.abas?.map((aba) => aba.nome);
  const anexoInput = colunas?.Dados?.anexo;

  const [chooseAba, setChooseAba] = useState('');
  const [chooseForm, setChooseForm] = useState('');
  const [themeColor, setThemeColor] = useState('#0fa697');
  const [corFundo, setCorFundo] = useState('');
  const [contrastColor, setConstratColor] = useState('');

  const [load, setLoad] = useState(false);
  const [blockReg, setBlockReg] = useState(false);
  const [blockList, setBlockList] = useState([]);
  const [showWarning, setShowWarning] = useState(false);
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);
  const [showDeleteFileWarning, setShowDeleteFileWarning] = useState('');

  const [showSubform, setShowSubform] = useState('');
  const [subformForm, setSubformForm] = useState({});
  const [subformResults, setSubformResults] = useState({});
  const [defaultData, setDefaultData] = useState({});

  const [itemsObrigatorios, setItemsObrigatorios] = useState([]);
  const [formError, setFormError] = useState(false);
  const [activateControls, setActivateControls] = useState(false);

  const [acoes, setAcoes] = useState({});
  const [consultaAcao, setConsultaAcao] = useState(false);
  const [acaoParametros, setAcaoParametros] = useState({});
  const [acaoParametrosResult, setAcaoParametrosResult] = useState({});
  const [thisAcaoName, setThisAcaoName] = useState('');

  const [consultaModal, setConsultaModal] = useState(null);
  const [consultaTitulo, setConsultaTitulo] = useState(null);
  const [consultaData, setConsultaData] = useState(null);

  const [relatorios, setRelatorios] = useState({});
  const [relatorioModal, setRelatorioModal] = useState(false);
  const [selectRelatorio, setSelectedRelatorio] = useState('');
  const [relatorioModo, setRelatorioModo] = useState('');
  const [relatorioFinal, setRelatorioFinal] = useState({});
  const [selectPdf, setSelectPdf] = useState();
  const [showListaRelatorios, setShowListaRelatorios] = useState();

  const [rateioTable, setRateioTable] = useState(false);
  const [rateioValue, setRateioValue] = useState(null);

  const [centroDeCustos, setCentroDeCustos] = useState(false);
  const [showCentroDeCustos, setShowCentroDeCustos] = useState(false);

  const [extraDataResults, setExtraDataResults] = useState([]);

  const [anexos, setAnexos] = useState([]);
  const [defAnexos, setDefAnexos] = useState([]);
  const [arquivo, setArquivo] = useState([]);
  const [files, setFiles] = useState([]);

  const [listType, setListType] = useState('normal');
  const [showAbaTodos, setShowAbaTodos] = useState(false);

  const { setLogData, setLoadIndex } = useContext(LogContext);

  const [mobileControls, setMobileControls] = useState(false);

  const isAdm =
    localStorage.getItem('IsAdm') === 'S' ||
    localStorage.getItem('IsAdm') === true;

  function SearchAnexos() {
    if (anexoInput?.mostrar === 'S') {
      const keys = anexoInput?.endpoint?.caminho?.split(',') || [];
      const hasEmptyValue = keys.some((key) => !isValid(subformForm[key]));
      const pasta = anexoInput?.endpoint?.pasta;

      if (!hasEmptyValue && isValid(pasta)) {
        const caminho = keys?.map((key) => subformForm[key]).join('/');
        const caminhoFinal = `${pasta?.replace(/\/$/, '')}/${caminho}`;

        fileService
          .listFiles(anexoInput.endpoint.url, caminhoFinal)
          .then((data) => setFiles(data))
          .catch((error) => showToast('error', error.message));
      }
    }
  }

  function HandleOnClose() {
    setLoad(false);
    forceUpdate();
    showSubform != '' ? setShowWarning(true) : onClose();
  }

  const titulo = Object.entries(colunas?.Dados || {}).find(
    ([key]) => key === 'titulo'
  )?.[1];

  const subformColunas = useMemo(() => colunas?.Dados, [colunas]);

  const subformGeral = dados[0]?.children?.filter((item) => {
    return (
      !item.name.toLowerCase().includes('coluna') &&
      Object.keys(subformColunas || {}).includes(item.name)
    );
  });

  const handleClose = () => {
    onClose;
    //setConsultaData(null);
  };
  const handleSetSearch = (data) => {
    setConsultaModal(false);
    setConsultaData(null);
    setConsultaTitulo('');

    setSubformForm((prev) => ({
      ...prev,
      ...data,
    }));

    getButtons();
  };

  const formatData = (data) => {
    const [dataAno, dataMes, dataDia] = data.split('-');
    return `${dataDia}/${dataMes}/${dataAno}`;
  };

  const [buttons, setButtons] = useState([]);
  function getButtons() {
    setRateioValue(dados?.rateiovalor?.replace('usu_', ''));

    const newButtons = Object.entries(subformColunas || {})?.map(
      ([key, item], index) => {
        let tipo = 'text';
        switch (item.tipo) {
          case 'string':
            tipo = 'text';
            break;
          case 'integer':
            tipo = 'number';
            break;
          case 'float':
            tipo = 'number';
            break;
          case 'date':
            tipo = 'date';
            break;
          case 'webservice':
            tipo = 'consulta';
            break;
          case 'webserviceexterno':
            tipo = 'consulta';
            break;
          case 'webservicemodulo':
            tipo = 'consulta';
            break;
          case 'select':
            tipo = 'select';
            break;
          case 'select2':
            tipo = 'select2';
            break;
          default:
            tipo = 'text';
            break;
        }

        const excludeKeys = [
          'abas',
          'titulo',
          'endpoint',
          'relatorios',
          'acoes',
          'repete',
          'downloadupload',
          'gridsalvar',
          'griddeletar',
          'rateio',
          'rateiovalor',
          'corfundo',
          'anexo',
        ];

        const thisBlock = blockList.includes(key);

        const thisTabIndex = Number(item?.posicao) + 900;

        if (isValid(item?.corborda)) setThemeColor(item?.corborda);

        if (abas?.length < 1 || chooseAba === '' || item.id === chooseAba) {
          if (!excludeKeys.includes(key) && item.mostrar != 'N') {
            let valor = subformForm[key] !== undefined ? subformForm[key] : '';

            if (tipo === 'date' && valor) {
              const [day, month, year] = valor.split('/');
              valor = `${year}-${month}-${day}`;
            }

            const defaultInput =
              tipo !== 'consulta' && tipo !== 'select' && tipo !== 'select2';

            return (
              <div
                key={index}
                className={`tamanho${item.tamanho}`}
                style={{ order: `${item.posicao}` }}
              >
                {defaultInput && (
                  <CustomInput
                    Class={
                      item.obrigatorio === 'S' && !isValid(subformForm[key])
                        ? 'obr'
                        : ''
                    }
                    PlaceHolder={`${item.nome} ${item.obrigatorio === 'S' ? '*' : ''} ${thisBlock ? '🔒' : ''}`}
                    Key={isAdm ? key : null}
                    Type={tipo}
                    OnChange={(e) => {
                      if (tipo === 'date') {
                        setSubformForm((prev) => ({
                          ...prev,
                          [key]: formatData(e.target.value),
                        }));
                      } else {
                        setSubformForm((prev) => ({
                          ...prev,
                          [key]: e.target.value,
                        }));
                      }
                    }}
                    Disabled={item.editavel === 'N' || thisBlock}
                    CorFundo={item.corfundo}
                    CorTexto={item.cortexto}
                    Color={item.corborda}
                    DefaultValue={valor}
                    TabIndex={item.editavel !== 'N' ? thisTabIndex : 999} //--------------
                  />
                )}
                {tipo === 'consulta' && (
                  <ConsultaInput
                    Class={
                      item.obrigatorio === 'S' && !isValid(subformForm[key])
                        ? 'obr'
                        : ''
                    }
                    PlaceHolder={`${item.nome} ${item.obrigatorio === 'S' ? '*' : ''} ${thisBlock ? '🔒' : ''}`}
                    Key={isAdm ? key : null}
                    Type={tipo}
                    OnPress={() => {
                      setConsultaModal(true);
                      setConsultaData(item);
                      setConsultaTitulo(item.nome);
                    }}
                    OnChange={(e) =>
                      setSubformForm((prev) => ({
                        ...prev,
                        [key]: e.target.value,
                      }))
                    }
                    Disabled={item.editavel === 'N' || thisBlock}
                    CorFundo={item.corfundo}
                    CorTexto={item.cortexto}
                    Color={item.corborda}
                    DefaultValue={valor}
                    TabIndex={item.editavel !== 'N' ? thisTabIndex : 999} //--------------
                  />
                )}
                {tipo === 'select' && (
                  <SelectInput
                    Class={
                      item.obrigatorio === 'S' && !isValid(subformForm[key])
                        ? 'obr'
                        : ''
                    }
                    PlaceHolder={`${item.nome} ${item.obrigatorio === 'S' ? '*' : ''} ${thisBlock ? '🔒' : ''}`}
                    Key={isAdm ? key : null}
                    Type={tipo}
                    OnChange={(e) => {
                      setSubformForm((prev) => ({
                        ...prev,
                        [key]: e.target.value,
                      }));
                    }}
                    Disabled={item.editavel === 'N' || thisBlock}
                    Options={item.options}
                    CorFundo={item.corfundo}
                    CorTexto={item.cortexto}
                    Color={item.corborda}
                    DefaultValue={valor}
                    TabIndex={item.editavel !== 'N' ? thisTabIndex : 999} //--------------
                  />
                )}
                {tipo === 'select2' && (
                  <SelectInput2
                    Class={
                      item.obrigatorio === 'S' && !isValid(subformForm[key])
                        ? 'obr'
                        : ''
                    }
                    PlaceHolder={`${item.nome} ${item.obrigatorio === 'S' ? '*' : ''} ${thisBlock ? '🔒' : ''}`}
                    Key={isAdm ? key : null}
                    Type={'select'}
                    OnChange={(e) => {
                      setSubformForm((prev) => ({
                        ...prev,
                        [key]: e.target.value,
                      }));
                    }}
                    Disabled={item.editavel === 'N' || thisBlock}
                    Options={item.options}
                    Filtro={item.origemFiltro.map((item, index) => {
                      return subformForm[item];
                    })}
                    CorFundo={item.corfundo}
                    CorTexto={item.cortexto}
                    Color={item.corborda}
                    DefaultValue={valor}
                    TabIndex={item.editavel !== 'N' ? thisTabIndex : 999} //--------------
                  />
                )}
              </div>
            );
          }
        }
        return null;
      }
    );

    setButtons(newButtons);
  }

  function HandleSaveSub(acao, extraData) {
    if (acao === 1) {
      subformForm.rateio = extraData.rateio;
      setCentroDeCustos(false);
      return;
    }

    setLoad(true);
    setTimeout(() => {
      setLoad(false);
      setShowSubform(false);
      setChooseForm('');
    }, 500);

    const newData = { ...extraData };

    setExtraDataResults((prev) => ({
      ...prev,
      ...extraData,
    }));
  }

  async function HandleEdit(acao, extraData) {
    if (blockReg) return;

    const allData = dados;
    let myDados = {};
    let colunas = {};

    Object.entries(allData || {}).forEach(([key, value]) => {
      if (!value.name || !value.name.includes('Colunas')) {
        myDados[key] = value;
      } else {
        colunas[value.name.replace(/Colunas$/i, '')] = value.value;
      }
    });

    let mergedColumns = extraData;

    const myData = dados;

    const mergedForm = Object.fromEntries(
      Object.entries(subformForm || {})?.map(([key, value]) => [
        key,
        value !== '' ? value : (myData?.[key] ?? value),
      ])
    );

    const checkItemsObrigatorios = itemsObrigatorios.every((key) => {
      return isValid(mergedForm[key]);
    });

    if (!checkItemsObrigatorios) {
      setFormError(true);
      return;
    }

    const keys = anexoInput?.endpoint?.caminho?.split(',') || [];
    const hasEmptyValue = keys.some((key) => !isValid(subformForm[key]));
    const pasta = anexoInput?.endpoint?.pasta;

    console.log(extraDataResults);

    try {
      const postConfig = {
        codemp: idEmp,
        codfil: idFil,
        ...extraDataResults,
        ...mergedForm,
        ...mergedColumns,
        tipAca: acao,
        ...formatarArquivos(arquivo),
      };

      setLoad(true);

      const res = await GetProcesso(config[0], postConfig, true, false);

      if (isRetornoSucesso(res)) {
        HandleOnClose();
      }
    } catch (error) {
      console.error('Erro ao salvar:', error);
    } finally {
      setLoad(false);
    }
  }
  function formatarArquivos(anexos) {
    const resultado = {};
    anexos.forEach((item, index) => {
      resultado[`dadosanexo(${index})`] = item;
    });
    return resultado;
  }

  function HandleAcao(botaoAcao) {
    setThisAcaoName(botaoAcao.nome);
    setAcaoParametrosResult({});

    const parametros = {};

    Object.entries(botaoAcao).forEach(([key, value]) => {
      if (
        typeof value === 'object' &&
        value !== null &&
        !Array.isArray(value)
      ) {
        parametros[key] = value;
      }
    });

    setAcaoParametros((prev) => ({
      ...{ config: botaoAcao },
      ...parametros,
    }));

    if (isValid(parametros)) {
      setConsultaAcao(true);
    } else {
      HandleAcaoConsulta();
    }
  }

  function HandleAcaoConsulta(url) {
    const config = acaoParametros.config;

    setLoad(true);

    GetProcesso(config.porta, acaoParametrosResult, true, false)
      .then((res) => {
        const raw = transformResponse(res, 'result');

        const results = raw[0].children?.filter((item) => {
          return (
            isValid(item.value) && item.value !== '0' && item.value !== '0.0'
          );
        });

        const convertArrayToObject = (arr) => {
          const obj = {};

          arr.forEach((item) => {
            if (item.name && item.value != null) {
              if (item.name === 'tipRet') obj[thisAcaoName] = item.value;
              else obj[item.name] = item.value;
            }
          });

          return obj;
        };

        const finalResults = convertArrayToObject(results);

        const mergedForm = {
          ...subformForm,
          ...finalResults,
        };

        setSubformForm((prev) => ({
          ...prev,
          ...finalResults,
        }));
      })
      .catch((error) => {
        showToast('error', error);
      })
      .finally(() => {
        setLoad(false);
        setConsultaAcao(false);
      });
  }

  function handleConsultaRelatorio(data) {
    const filteredData = Object.fromEntries(
      Object.entries(data).filter(([_, value]) => isValid(value))
    );

    const thisData = {
      arqJso: JSON.stringify({
        ...filteredData,
        codemp: idEmp,
        codfil: idFil,
        tipAca: 'ADI',
      }),
    };

    GetProcesso(selectRelatorio.porta, thisData, true, true)
      .then((res) => {
        const relatorio = JSON.parse(res.arqJso);

        if (typeof relatorio === 'object') setRelatorioFinal(relatorio);
        else {
          setRelatorioFinal({});
        }
      })
      .catch((error) => {
        showToast('error', error);
      })
      .finally(() => {
        setLoad(false);
      });

    setRelatorioModo('lista');
  }

  async function handleAddFile(file) {
    if (!file) return;

    const arquivoConvertido = {
      nomarq: file.name,
      basarq: await toBase64(file),
      tipaca: 'I',
    };

    setAnexos((prev) => [...prev, file]);
    setArquivo((prev) => [...(prev || []), arquivoConvertido]);
  }
  function handleExcludeFile(fileToRemove) {
    if (fileToRemove?.nomarq && fileToRemove?.basarq) {
      setDefAnexos((prev) =>
        prev?.filter((item) => item.nomarq !== fileToRemove.nomarq)
      );

      setArquivo((prev) => {
        const existe = prev?.some(
          (item) => item.nomarq === fileToRemove.nomarq
        );

        if (existe) {
          return prev.map((item) =>
            item.nomarq === fileToRemove.nomarq
              ? { ...item, tipaca: 'D', basarq: null }
              : item
          );
        } else {
          return [
            ...(prev || []),
            { ...fileToRemove, tipaca: 'D', basarq: null },
          ];
        }
      });
    } else {
      setAnexos((prev) => prev?.filter((file) => file !== fileToRemove));

      setArquivo((prev) =>
        prev
          ?.filter((item) => {
            if (item.nomarq === fileToRemove.name && item.tipaca === 'I')
              return false;
            return true;
          })
          .map((item) => {
            if (item.nomarq === fileToRemove.name)
              return { ...item, tipaca: 'D', basarq: null };
            return item;
          })
      );
    }
  }
  function handleGetFile(file) {
    if (!file?.basarq || !file?.nomarq) {
      showToast('error', 'Arquivo inválido.');
      return;
    }

    const byteCharacters = atob(file.basarq);
    const byteNumbers = Array.from(byteCharacters, (char) =>
      char.charCodeAt(0)
    );
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = file.nomarq;
    a.click();
    window.URL.revokeObjectURL(url);
  }
  function handleRemoveFile(fileName) {
    setShowDeleteFileWarning(fileName);
  }
  function handleDeleteFile(fileName) {
    setLoad(true);

    const keys = anexoInput?.endpoint?.caminho?.split(',') || [];
    const hasEmptyValue = keys.some((key) => !isValid(subformForm[key]));
    const pasta = anexoInput?.endpoint?.pasta;

    if (anexoInput?.mostrar === 'S' && (hasEmptyValue || !isValid(pasta))) {
      showToast('error', 'Caminho dos anexos não especificado.');
      return;
    }

    const caminho = keys?.map((key) => subformForm[key]).join('/');
    const caminhoFinal = `${pasta?.replace(/\/$/, '')}/${caminho}`;

    fileService
      .deleteFiles(anexoInput.endpoint.url, caminhoFinal, [fileName])
      .then(() => SearchAnexos())
      .catch((error) => showToast('error', error.message))
      .finally(() => {
        setTimeout(() => {
          setLoad(false);
        }, 500);
      });
  }

  //----------------------------------------USE-EFFECT------------------------------------------------------

  useEffect(() => {
    const allData = { ...data };

    setBlockReg(dados?.bloreg === 'S');
    setCorFundo(colunas?.Dados?.corfundo);
    setConstratColor(isDark(colunas?.Dados?.corfundo));

    const rawString = dados?.colblo?.match(/\w+/g) || [];
    const valuesArray = rawString.slice(1);
    setBlockList(valuesArray);

    setSubformForm((prev) =>
      Object.keys(subformColunas || {})?.reduce((acc, key) => {
        acc[key] = allData[key] !== undefined ? allData[key] : '';
        return acc;
      }, {})
    );

    setAcoes(colunas?.Dados?.acoes);

    const subformKeys = Object.keys(dados)?.filter((item) =>
      item?.toLowerCase()?.includes('colunas')
    );

    const subformKeyNames = subformKeys
      .filter((item) => item.replace(/Colunas$/i, '') !== 'nome')
      .map((item) => item.replace(/Colunas$/i, ''));

    const subformDefaultData = Object.keys(dados)?.filter((item) =>
      subformKeyNames.some((key) => item.toLowerCase() === key.toLowerCase())
    );

    const transformData = (subformKeys) => {
      return subformKeys.reduce((acc, key, index) => {
        const itemData = dados?.[key];
        if (typeof itemData !== 'object' || !itemData) return acc;
        acc[`${key}(${index})`] = Object.entries(itemData).reduce(
          (obj, [k, v]) => {
            obj[k] = v;
            return obj;
          },
          {}
        );
        return acc;
      }, {});
    };

    const transformedData = transformData(subformDefaultData);
    setExtraDataResults(transformedData);

    const anexos = allData?.dadosanexo;
    const listaAnexos = Array.isArray(anexos) ? anexos : [anexos];
    setDefAnexos(listaAnexos);

    setShowCentroDeCustos(config[0]?.includes('CadSupOrdemCompra'));
  }, [data, colunas, subformColunas]);

  useEffect(() => {
    const obrigatorios = Object.entries(subformColunas || {})
      ?.filter(([_, item]) => item.obrigatorio === 'S')
      ?.map(([key]) => key);

    setItemsObrigatorios(obrigatorios);
  }, [subformColunas]);

  useEffect(() => {
    const checkItemsObrigatorios = itemsObrigatorios.every((key) => {
      return subformForm[key] !== '';
    });

    setActivateControls(checkItemsObrigatorios);
  }, [itemsObrigatorios, subformForm]);

  useEffect(() => {
    setLoadIndex((prev) => ({
      ...prev,
      [tabIndex]: load,
    }));
  }, [load, tabIndex, setLoadIndex]);

  useEffect(() => {
    getButtons();

    if (!isValid(titulo)) {
      showToast('error', 'Erro ao consultar registro.');
    }
  }, [subformForm, chooseAba, titulo]);

  useEffect(() => {
    if (!dados) return;

    /*
    setDefaultData(
      dados.reduce((acc, item) => {
        acc[item.name] = item.value;
        return acc;
      }, {})
    );*/

    setRelatorios(colunas.Dados?.relatorios || {});
    setShowListaRelatorios(isValid(colunas.Dados?.relatorios));

    setChooseAba(isValid(abas) ? abas[0] : '');
  }, [data]);

  useEffect(() => {
    SearchAnexos();
  }, [anexoInput, subformForm]);

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result.split(',')[1];
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  //-----------------

  return (
    <div
      className={`popup absoluteCenter mobileFullscreen ${formError ? 'erro' : ''} ${blockReg ? 'block' : ''}`}
    >
      {showDeleteWarning && (
        <div className="modal absoluteCenter consultaModal">
          <p>Tem certeza que deseja deletar este item?</p>
          <div className="list">
            <button
              className="mainButton red"
              onClick={() => setShowDeleteWarning(false)}
            >
              <End />
              Cancelar
            </button>
            <button
              className="mainButton turquoise"
              onClick={() => {
                setShowDeleteWarning(false);
                HandleEdit('R');
              }}
            >
              <Check /> Deletar
            </button>
          </div>
        </div>
      )}

      {showDeleteFileWarning !== '' && (
        <div className="modal absoluteCenter consultaModal">
          <p>Tem certeza que deseja deletar este arquivo?</p>
          <div className="list">
            <button
              className="mainButton red"
              onClick={() => setShowDeleteFileWarning('')}
            >
              <End />
              Cancelar
            </button>
            <button
              className="mainButton turquoise"
              onClick={() => {
                handleDeleteFile(showDeleteFileWarning);
                setShowDeleteFileWarning('');
              }}
            >
              <Check /> Deletar
            </button>
          </div>
        </div>
      )}

      {rateioTable && (
        <>
          <Rateios
            defaultValue={rateioValue}
            onClose={() => setRateioTable(false)}
            Title={titulo}
            blocked={blockReg}
          />
        </>
      )}

      {centroDeCustos && (
        <>
          <CentroDeCusto
            defaultValue={rateioValue}
            onClose={() => setCentroDeCustos(false)}
            Title={titulo}
            blocked={blockReg}
            ordemCompra={subformForm.numocp}
            fornecedor={subformForm.codfor}
            saveFunction={HandleSaveSub}
            origem={1}
          />
        </>
      )}

      <div
        className={`wrap ${showSubform ? 'normal' : listType}`}
        style={{ backgroundColor: isValid(corFundo) ? corFundo : 'inherit' }}
      >
        {relatorioModal && (
          <>
            <button
              className="subFormFade"
              onClick={() => setRelatorioModal(false) /*handleClose*/}
            />

            <div
              className={`modal absoluteCenter relatoriosModal ${relatorioModo}`}
            >
              {load && <div className="subFormFade" />}

              <span className="header">
                <span className="title">
                  <h2>
                    Relatórios <hr />
                  </h2>
                </span>
                {relatorioModo === 'resultado' && (
                  <button
                    className="mainButton turquoise"
                    onClick={() => {
                      setRelatorioModo('consulta');
                    }}
                  >
                    Retornar
                  </button>
                )}
              </span>

              {relatorioModo === '' && (
                <div>
                  {Object.entries(relatorios || {})?.map(([key, item]) => {
                    return (
                      <button
                        key={key}
                        className="mainButton turquoise"
                        onClick={() => {
                          setSelectedRelatorio(item);
                          setRelatorioModo('consulta');
                          setLoad(true);
                        }}
                      >
                        {item.nome}
                      </button>
                    );
                  })}

                  <span className="submitRow">
                    <button
                      className="mainButton turquoise"
                      onClick={() => setRelatorioModal(false)}
                    >
                      retornar
                    </button>
                  </span>
                </div>
              )}

              {relatorioModo === 'consulta' && (
                <RenderForm
                  data={selectRelatorio}
                  onSubmit={() => handleConsultaRelatorio(subformForm)}
                />
              )}

              {relatorioModo === 'lista' && !load && (
                <div className="relatorioLista">
                  {(relatorioFinal?.Dados || [])?.map((item, index) => (
                    <button
                      className="relatorioItem"
                      key={index}
                      onClick={() => {
                        newTab(item.nome, <RenderPdf data={item.base64} />);
                      }}
                    >
                      <Pdf />
                      <span>
                        {item.nome}
                        <hr />
                      </span>
                    </button>
                  ))}

                  <span className="submitRow">
                    <button
                      className="mainButton turquoise"
                      onClick={() => setRelatorioModo('')}
                    >
                      retornar
                    </button>
                  </span>
                </div>
              )}

              {/*relatorioModo === 'resultado' && <RenderPdf data={selectPdf} />*/}
            </div>
          </>
        )}

        {abas?.length > 0 && (
          <div className={`formTabs ${contrastColor}`}>
            {showAbaTodos && (
              <button
                className={`formTabItem ${chooseAba === '' ? 'active' : 'notActive'}`}
                style={{
                  backgroundColor: isValid(corFundo) ? corFundo : 'inherit',
                  color: contrastColor,
                }}
                onClick={() => setChooseAba('')}
              >
                Todos
              </button>
            )}

            {abas?.map((item, index) => (
              <button
                key={index}
                className={`formTabItem ${chooseAba === item ? 'active' : 'notActive'}`}
                style={{
                  backgroundColor: isValid(corFundo) ? corFundo : 'inherit',
                  color: contrastColor,
                }}
                onClick={() => {
                  setChooseAba(item);
                }}
              >
                {item}
              </button>
            ))}
          </div>
        )}

        {showWarning && (
          <div className="warning absoluteCenter mainShadow">
            <p> Fechar </p> <span>formulário</span>
            <div>
              <button
                onClick={() => {
                  setShowSubform('');
                  setShowWarning(false);
                  setChooseForm('');
                }}
              >
                Sim
              </button>
              <button onClick={() => setShowWarning(false)}> Não </button>
            </div>
          </div>
        )}
        {showSubform && (
          <SubForm
            id={chooseForm}
            onClose={() => {
              setShowSubform(false);
              setChooseForm('');
            }}
            Class={showWarning ? 'fadeContent' : ''}
            allData={data}
            saveFunction={HandleSaveSub}
            myExtraData={extraDataResults}
            modo={'edit'}
            tabIndex={tabIndex}
            blockAdd={blockList.includes('Adicionar')}
            formData={subformForm}
          />
        )}
        {load && <LoadGif />}
        {load && (
          <div
            className="blockFade"
            style={{ backgroundColor: `${corFundo}` }}
          />
        )}
        <span className="title">
          <h2 style={{ color: contrastColor }}>
            Editar {titulo} {blockReg && <Lock title="Registro bloqueado." />}
            <hr
              style={{
                backgroundColor: themeColor,
                borderBlockColor: themeColor,
              }}
            />
          </h2>

          <div className={`listType ${contrastColor}`}>
            {isValid(abas) && (
              <button
                className={showAbaTodos ? 'active' : ''}
                onClick={() => {
                  if (!showAbaTodos) {
                    setShowAbaTodos(true);
                    setChooseAba('');
                  } else {
                    if (chooseAba === '')
                      setChooseAba(isValid(abas) && abas[0]);
                    setShowAbaTodos(false);
                  }
                }}
              >
                <label> Mostrar: Todos </label>
                <ShowTodos />
              </button>
            )}

            <button
              className={listType === 'normal' ? 'active' : ''}
              onClick={() => setListType('normal')}
            >
              <label> Layout: Padrão </label>
              <TypeNormal />
            </button>
            <button
              className={listType === 'list' ? 'active' : ''}
              onClick={() => setListType('list')}
            >
              <label> Layout: Lista </label>
              <TypeList />
            </button>
          </div>
        </span>
        <div className="content scroll">
          <div className="column">
            <div className={listType}>
              {consultaAcao && (
                <>
                  <button
                    className="subFormFade"
                    onClick={() => setConsultaAcao(false) /*handleClose*/}
                  />
                  <div className="modal absoluteCenter consultaModal">
                    {acaoParametros &&
                      Object.entries(acaoParametros)?.map(([key, item]) => {
                        if (key != 'config')
                          return (
                            <CustomInput
                              Disabled={key in subformForm}
                              key={key}
                              PlaceHolder={item.nome}
                              DefaultValue={subformForm[key] || ''}
                              OnChange={(e) => {
                                setAcaoParametrosResult((prev) => ({
                                  ...prev,
                                  [key]: e.target.value,
                                }));
                              }}
                            />
                          );
                      })}

                    <div>
                      <button
                        onClick={() => setConsultaAcao(false)}
                        className="mainButton red"
                      >
                        Retornar
                      </button>
                      <button
                        onClick={() => HandleAcaoConsulta()}
                        className="mainButton turquoise"
                      >
                        Avançar
                      </button>
                    </div>
                  </div>
                </>
              )}

              {consultaModal && (
                <>
                  <button
                    className="subFormFade"
                    onClick={() => setConsultaModal(false) /*handleClose*/}
                  />

                  <div className="modal absoluteCenter consultaModal">
                    <SearchTable
                      webservice={consultaData}
                      SetSearch={handleSetSearch}
                      Titulo={consultaTitulo}
                      extraData={subformForm}
                      extraExtraData={data}
                      onClose={() => setConsultaModal(false)}
                      defaultData={defaultData}
                      tabIndex={tabIndex}
                      url={consultaData.endpoint.url}
                    />
                  </div>
                </>
              )}

              {buttons}

              {anexoInput?.mostrar === 'S' && anexoInput.id === chooseAba && (
                <Anexos
                  Editavel={anexoInput?.editavel === 'S' && !blockReg}
                  Config={anexoInput}
                  OnChange={handleAddFile}
                  RemoveAnexo={handleExcludeFile}
                  GetFile={handleGetFile}
                  RemoveFile={handleRemoveFile}
                  Anexos={anexos}
                  DefaultData={defAnexos}
                  Files={files}
                />
              )}
            </div>

            <div className={`acoes ${listType}`}>
              {isValid(acoes) &&
                Object.entries(acoes || {})?.map(([key, item]) => {
                  const thisBlock = blockList.includes(key);

                  if (
                    abas?.length < 1 ||
                    chooseAba === '' ||
                    item.id === chooseAba
                  ) {
                    return (
                      <div
                        className={`acao tipo${item.tipo} ${thisBlock ? 'disabled' : ''}`}
                        key={key}
                        style={{ backgroundColor: item.corfundo }}
                      >
                        <button
                          onClick={() => HandleAcao(item)}
                          disabled={blockReg || thisBlock}
                        >
                          {!isValid(item.icone) && <Plug />}
                          {!isValid(item.icone) && <Plugged />}

                          {isValid(item.icone) && (
                            <img
                              src={item.icone}
                              onError={(e) => {
                                e.currentTarget.src = DefIcon;
                              }}
                            />
                          )}
                        </button>
                        <span style={{ color: item.corfonte }}>
                          {item.tipo === 'botao'
                            ? item.nome
                            : subformForm[item.nome] || item.nome}
                        </span>
                        {isValid(subformForm[item.nome]) &&
                          item.tipo !== 'botao' && (
                            <label style={{ backgroundColor: item.corfundo }}>
                              {`${item.nome} ${thisBlock ? '🔒' : ''}`}
                            </label>
                          )}
                      </div>
                    );
                  }
                })}
            </div>

            {formError && (
              <h5 style={{ order: '1000' }}>
                Verifique se todos os items obrigatórios foram preenchidos
              </h5>
            )}
          </div>
        </div>
      </div>
      <div
        className={`controls ${!activateControls ? 'disabled' : ''} ${mobileControls ? 'mobileControls' : ''} ${showSubform ? 'deactive' : ''}`}
        style={{ backgroundColor: isValid(corFundo) ? corFundo : 'inherit' }}
      >
        <span className={`mobileHandler ${contrastColor}`}>
          <button
            className={mobileControls ? 'active' : ''}
            onClick={() => setMobileControls(!mobileControls)}
            style={{
              backgroundColor: isValid(corFundo) ? corFundo : 'inherit',
            }}
          >
            <Menu />
          </button>
        </span>

        <button
          className={`icon cancelar ${showSubform ? 'hideIt' : ''}`}
          onClick={onClose}
          disabled={chooseForm != '' || load}
        >
          Cancelar <GoBack />
        </button>

        <button
          className={`icon deletar ${showSubform ? 'hideIt' : ''}`}
          onClick={() => {
            setShowDeleteWarning(true);
          }}
          disabled={
            chooseForm != '' || blockReg || blockList.includes('Deletar')
          }
        >
          {`Deletar ${blockList.includes('Deletar') ? '🔒' : ''}`}{' '}
          <DeleteIcon />
        </button>

        <button
          className={`icon salvar ${showSubform ? 'hideIt' : ''}`}
          onClick={() => {
            HandleEdit('A');
          }}
          disabled={
            load || chooseForm != '' || blockReg || blockList.includes('Salvar')
          }
        >
          {`Salvar ${blockList.includes('Salvar') ? '🔒' : ''}`} <ArchiveIcon />
        </button>

        {showRateio && (
          <div className={`controle`}>
            <span />
            <button
              onClick={() => {
                if (relatorioModal) setRelatorioModal(false);

                const foundItem = Object.entries(subformForm).find(
                  ([key]) =>
                    key ===
                    data?.colunas?.Dados?.rateiovalor?.replace('usu_', '')
                )?.[1];

                setRateioValue(
                  isValid(foundItem)
                    ? foundItem
                    : defaultData[
                        data?.colunas?.Dados?.rateiovalor?.replace('usu_', '')
                      ]
                );

                setRateioTable(true);
              }}
            >
              Rateio
            </button>
          </div>
        )}

        {showListaRelatorios && (
          <div className={`controle`}>
            <span />
            <button
              onClick={() => {
                setRelatorioModo('');
                setRelatorioModal(true);
              }}
            >
              Relatórios
            </button>
          </div>
        )}

        {controls?.map((item, index) => {
          const titulo = dados[item]
            ? JSON.parse(dados[item]).Dados.titulo
            : '';

          if (item != 'nomeColunas')
            return (
              <div key={index} className="controle">
                <button
                  className={chooseForm === item ? 'active' : ''}
                  onClick={() => {
                    setMobileControls(false);
                    if (!relatorioModal) {
                      if (chooseForm !== item) {
                        setChooseForm('');
                        setShowSubform(false);

                        setTimeout(() => {
                          setChooseForm(item);
                          setShowSubform(true);
                        }, 10);
                      } else {
                        setChooseForm('');
                        setShowSubform(false);
                      }
                    } else {
                      setRelatorioModal(false);
                    }
                  }}
                >
                  {titulo}
                </button>
              </div>
            );
        })}

        {/*<button
          onClick={() => {
            console.log(subformForm, extraDataResults);
          }}
        >
          Log
        </button>*/}

        {showCentroDeCustos && !showSubform && (
          <div className={`controle`}>
            <span />
            <button
              onClick={() => {
                setCentroDeCustos(true);
              }}
            >
              Rateio
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

SubformEditar.propTypes = {
  onClose: PropTypes.func.isRequired,
  forceUpdate: PropTypes.func,
  children: PropTypes.node,
  controls: PropTypes.array,
  data: PropTypes.object,
  config: PropTypes.array,
  rowData: PropTypes.object,
  tabIndex: PropTypes.number,
};
